module.exports = __webpack_public_path__ + "img/7dd91d4.jpg";